import AuthService from '@/services/auth.service'

const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
if (user) { user.userData = JSON.parse(user.userData) }
const initialState = user
  ? { status: { loggedIn: true }, user: user }
  : { status: { loggedIn: false }, user: null }

export default {
  namespaced: true,
  state: initialState,
  actions: {
    login ({ commit }, user) {
      return AuthService.login(user).then(res => {
        res.userData = JSON.parse(res.userData)
        commit('loginSuccess', res)
        let to = '/'
        if (res.userData.userRoleNames.includes('Admin')) { to = '/admin/dashboard' } else if (res.userData.userRoleNames.includes('Member')) { to = '/member/dashboard' }
        return Promise.resolve(to)
      }).catch(error => {
        commit('loginFailure')
        return Promise.reject(error)
      })
    },
    logout ({ commit }) {
      AuthService.logout()
      commit('logout')
    },
    register ({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit('registerSuccess')
          return Promise.resolve(response.data)
        },
        error => {
          commit('registerFailure')
          return Promise.reject(error)
        },
      )
    },
    getUser ({ commit }) {

    },
  },
  mutations: {
    loginSuccess (state, user) {
      state.status.loggedIn = true
      state.user = user
    },
    loginFailure (state) {
      state.status.loggedIn = false
      state.user = null
    },
    logout (state) {
      state.status.loggedIn = false
      state.user = null
    },
    registerSuccess (state) {
      state.status.loggedIn = false
    },
    registerFailure (state) {
      state.status.loggedIn = false
    },
  },
  getters: {
    getCurrentUser: (state) => {
      return state.user
    },
  },
}
